module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.l = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// identity function for calling harmory imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };

/******/ 	// define getter function for harmory exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		Object.defineProperty(exports, name, {
/******/ 			configurable: false,
/******/ 			enumerable: true,
/******/ 			get: getter
/******/ 		});
/******/ 	};

/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};

/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 114);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 1 */
/***/ function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(3)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ },
/* 3 */
/***/ function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ },
/* 4 */
/***/ function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ },
/* 5 */
/***/ function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ },
/* 6 */
/***/ function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

var global    = __webpack_require__(1)
  , core      = __webpack_require__(0)
  , ctx       = __webpack_require__(23)
  , hide      = __webpack_require__(10)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ },
/* 9 */
/***/ function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(11)
  , createDesc = __webpack_require__(17);
module.exports = __webpack_require__(2) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(7)
  , IE8_DOM_DEFINE = __webpack_require__(31)
  , toPrimitive    = __webpack_require__(34)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(2) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(15)
  , defined = __webpack_require__(5);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(5);
module.exports = function(it){
  return Object(defined(it));
};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

exports.__esModule = true;

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(22);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(32)
  , enumBugKeys = __webpack_require__(25);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ },
/* 17 */
/***/ function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

var shared = __webpack_require__(26)('keys')
  , uid    = __webpack_require__(28);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

var store      = __webpack_require__(26)('wks')
  , uid        = __webpack_require__(28)
  , Symbol     = __webpack_require__(1).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ },
/* 21 */
/***/ function(module, exports) {

module.exports = require("vue");

/***/ },
/* 22 */
/***/ function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(29);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4)
  , document = __webpack_require__(1).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ },
/* 25 */
/***/ function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

var global = __webpack_require__(1)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(6)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ },
/* 28 */
/***/ function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ },
/* 29 */
/***/ function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(12)
  , toLength  = __webpack_require__(27)
  , toIndex   = __webpack_require__(33);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(2) && !__webpack_require__(3)(function(){
  return Object.defineProperty(__webpack_require__(24)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

var has          = __webpack_require__(9)
  , toIObject    = __webpack_require__(12)
  , arrayIndexOf = __webpack_require__(30)(false)
  , IE_PROTO     = __webpack_require__(18)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(6)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(4);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ },
/* 35 */
/***/ function(module, exports) {

module.exports = require("vuex");

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return validShortcuts; });

var model = {
  actions: {
    cmdShiftK: function cmdShiftK(_ref) {
      var dispatch = _ref.dispatch;

      dispatch('toggleAllPanels');
    },
    cmdShiftL: function cmdShiftL(_ref2) {
      var dispatch = _ref2.dispatch;

      dispatch('toggleLeftPanel');
    },
    cmdShiftD: function cmdShiftD(_ref3) {
      var dispatch = _ref3.dispatch;

      dispatch('toggleBottomPanel');
    },
    cmdShiftLeft: function cmdShiftLeft(_ref4) {
      var dispatch = _ref4.dispatch;

      dispatch('playPrevious');
    },
    cmdShiftRight: function cmdShiftRight(_ref5) {
      var dispatch = _ref5.dispatch;

      dispatch('playNext');
    }
  }
};

/* harmony default export */ exports["b"] = model;
var validShortcuts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(model.actions);

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony default export */ exports["a"] = function (spots, query) {
  var scenarios = spots[query.spot];
  if (scenarios) {
    var scenario = scenarios.filter(function (scenario) {
      return scenario.scenario === query.scenario;
    })[0];
    return scenario;
  }
};

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store_modules_shortcuts__ = __webpack_require__(36);
/* unused harmony export isModifierPressed */
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return parseKey; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return executeShortcut; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return observeKeyEvents; });


// Key codes
var keyK = 75;
var keyL = 76;
var keyD = 68;
var keyLeft = 37;
var keyRight = 39;
var keyWindows = 91;

var isModifierPressed = function isModifierPressed(e) {
  return (e.ctrlKey || e.keyCode === keyWindows || e.metaKey) && e.shiftKey;
};

var parseKey = function parseKey(e) {
  if (!isModifierPressed(e)) return false;

  switch (e.keyCode) {
    case keyK:
      e.preventDefault();
      return 'cmdShiftK';
    case keyL:
      e.preventDefault();
      return 'cmdShiftL';
    case keyD:
      e.preventDefault();
      return 'cmdShiftD';
    case keyLeft:
      e.preventDefault();
      return 'cmdShiftLeft';
    case keyRight:
      e.preventDefault();
      return 'cmdShiftRight';
    default:
      return false;
  }
};

var executeShortcut = function executeShortcut(store, combination) {
  if (combination) {
    if (!__WEBPACK_IMPORTED_MODULE_0_store_modules_shortcuts__["a" /* validShortcuts */].includes(combination)) {
      console.warn('Combination ' + combination + ' is not a valid shortcut');
      return;
    }
    store.dispatch(combination);
  }
};

var observeKeyEvents = function observeKeyEvents(store) {
  window.onkeydown = function (e) {
    var combination = parseKey(e);
    executeShortcut(store, combination);
  };
};

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(41), __esModule: true };

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(42), __esModule: true };

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

var core  = __webpack_require__(0)
  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(49);
module.exports = __webpack_require__(0).Object.assign;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(50);
module.exports = __webpack_require__(0).Object.keys;

/***/ },
/* 44 */
/***/ function(module, exports) {

module.exports = {};

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(16)
  , gOPS     = __webpack_require__(46)
  , pIE      = __webpack_require__(47)
  , toObject = __webpack_require__(13)
  , IObject  = __webpack_require__(15)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(3)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ },
/* 46 */
/***/ function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 47 */
/***/ function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(8)
  , core    = __webpack_require__(0)
  , fails   = __webpack_require__(3);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(8);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(45)});

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(13)
  , $keys    = __webpack_require__(16);

__webpack_require__(48)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home_vue__);




__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router___default.a);

/* harmony default export */ exports["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router___default.a({
  mode: 'history',
  routes: [{
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home_vue___default.a
  }]
});

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight__);

__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight___default.a.registerLanguage('json', __webpack_require__(109));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight___default.a.registerLanguage('javascript', __webpack_require__(108));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight___default.a.registerLanguage('xml', __webpack_require__(110));

/* harmony default export */ exports["a"] = __WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight___default.a;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return preventSelectStart; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return preventSelectStop; });
var preventSelectStart = function preventSelectStart() {
  document.onselectstart = function () {
    return false;
  };
};

var preventSelectStop = function preventSelectStop() {
  document.onselectstart = function () {
    return true;
  };
};

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* harmony default export */ exports["a"] = function (a, b) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(a).every(function (key) {
    return a[key] === b[key];
  });
};

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

var def = __webpack_require__(11).f
  , has = __webpack_require__(9)
  , TAG = __webpack_require__(19)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_layout__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_playspot__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_shortcuts__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_toys__ = __webpack_require__(61);








__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex___default.a);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex___default.a.Store({
  modules: {
    layout: __WEBPACK_IMPORTED_MODULE_2__modules_layout__["a" /* default */],
    playspot: __WEBPACK_IMPORTED_MODULE_3__modules_playspot__["a" /* default */],
    shortcuts: __WEBPACK_IMPORTED_MODULE_4__modules_shortcuts__["b" /* default */],
    toys: __WEBPACK_IMPORTED_MODULE_5__modules_toys__["a" /* default */]
  }
});

/* harmony default export */ exports["a"] = store;

/***/ },
/* 57 */,
/* 58 */
/***/ function(module, exports) {

module.exports = require("vuex-router-sync");

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* unused harmony export TOGGLE_LEFT_PANEL */
/* unused harmony export TOGGLE_BOTTOM_PANEL */
/* unused harmony export TOGGLE_ALL_PANELS */
/* unused harmony export UPDATE_SIDEBAR_WIDTH */
/* unused harmony export UPDATE_ACTIVE_TAB */
/* unused harmony export TOGGLE_HELP */
var TOGGLE_LEFT_PANEL = 'TOGGLE_LEFT_PANEL';
var TOGGLE_BOTTOM_PANEL = 'TOGGLE_BOTTOM_PANEL';
var TOGGLE_ALL_PANELS = 'TOGGLE_ALL_PANELS';
var UPDATE_SIDEBAR_WIDTH = 'UPDATE_SIDEBAR_WIDTH';
var UPDATE_ACTIVE_TAB = 'UPDATE_ACTIVE_TAB';
var TOGGLE_HELP = 'TOGGLE_HELP';

/* harmony default export */ exports["a"] = {
  state: {
    leftPanelExpanded: true,
    bottomPanelExpanded: true,
    sidebarWidth: 280,
    activeTab: null,
    showHelp: false
  },
  mutations: {
    TOGGLE_LEFT_PANEL: function TOGGLE_LEFT_PANEL(state) {
      state.leftPanelExpanded = !state.leftPanelExpanded;
    },
    TOGGLE_BOTTOM_PANEL: function TOGGLE_BOTTOM_PANEL(state) {
      state.bottomPanelExpanded = !state.bottomPanelExpanded;
    },
    UPDATE_SIDEBAR_WIDTH: function UPDATE_SIDEBAR_WIDTH(state, payload) {
      state.sidebarWidth = payload;
    },
    UPDATE_ACTIVE_TAB: function UPDATE_ACTIVE_TAB(state, payload) {
      state.activeTab = payload;
    },
    TOGGLE_HELP: function TOGGLE_HELP(state) {
      state.showHelp = !state.showHelp;
    }
  },
  actions: {
    toggleLeftPanel: function toggleLeftPanel(_ref) {
      var commit = _ref.commit;

      commit(TOGGLE_LEFT_PANEL);
    },
    toggleBottomPanel: function toggleBottomPanel(_ref2) {
      var commit = _ref2.commit;

      commit(TOGGLE_BOTTOM_PANEL);
    },
    toggleAllPanels: function toggleAllPanels(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;

      if (state.leftPanelExpanded && state.bottomPanelExpanded || !state.leftPanelExpanded && !state.bottomPanelExpanded) {
        commit(TOGGLE_LEFT_PANEL);
        commit(TOGGLE_BOTTOM_PANEL);
      } else {
        if (state.leftPanelExpanded) {
          commit(TOGGLE_LEFT_PANEL);
        }
        if (state.bottomPanelExpanded) {
          commit(TOGGLE_BOTTOM_PANEL);
        }
      }
    },
    updateSidebarWidth: function updateSidebarWidth(_ref4, payload) {
      var commit = _ref4.commit;

      commit(UPDATE_SIDEBAR_WIDTH, payload);
    },
    updateActiveTab: function updateActiveTab(_ref5, payload) {
      var commit = _ref5.commit;

      commit(UPDATE_ACTIVE_TAB, payload);
    },
    toggleHelp: function toggleHelp(_ref6) {
      var commit = _ref6.commit;

      commit(TOGGLE_HELP);
    }
  },
  getters: {
    leftPanelExpanded: function leftPanelExpanded(state) {
      return state.leftPanelExpanded;
    },
    bottomPanelExpanded: function bottomPanelExpanded(state) {
      return state.bottomPanelExpanded;
    },
    bottomPanelHeight: function bottomPanelHeight(state) {
      return state.bottomPanelHeight;
    },
    sidebarWidth: function sidebarWidth(state) {
      return state.sidebarWidth + 'px';
    },
    mainWidth: function mainWidth(state, getters) {
      return 'calc(100% - ' + getters.sidebarWidth + ')';
    },
    activeTab: function activeTab(state) {
      return state.activeTab;
    },
    showHelp: function showHelp(state) {
      return state.showHelp;
    }
  }
};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_array_find_index__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_shallow_equal__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_router__ = __webpack_require__(51);
/* unused harmony export UPDATE_CURRENT_SCENARIO */




var UPDATE_CURRENT_SCENARIO = 'UPDATE_CURRENT_SCENARIO';

var updateCurrent = function updateCurrent(state, payload) {
  state.current = payload;
};

/* harmony default export */ exports["a"] = {
  state: {
    current: null
  },
  mutations: {
    UPDATE_CURRENT_SCENARIO: updateCurrent
  },
  actions: {
    playNext: function playNext(_ref) {
      var commit = _ref.commit,
          getters = _ref.getters,
          state = _ref.state;

      var total = getters.playspotRoutes.length;
      var current = __WEBPACK_IMPORTED_MODULE_0_array_find_index___default()(getters.playspotRoutes, function (element) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_shallow_equal__["a" /* default */])(state.current, element);
      });
      var nextIndex = (current + 1) % total;
      var next = getters.playspotRoutes[nextIndex];
      commit(UPDATE_CURRENT_SCENARIO, next);
      __WEBPACK_IMPORTED_MODULE_2_router__["a" /* default */].push({ query: next });
    },
    playPrevious: function playPrevious(_ref2) {
      var commit = _ref2.commit,
          getters = _ref2.getters,
          state = _ref2.state;

      var total = getters.playspotRoutes.length;
      var current = __WEBPACK_IMPORTED_MODULE_0_array_find_index___default()(getters.playspotRoutes, function (element) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_shallow_equal__["a" /* default */])(state.current, element);
      });
      var prevIndex = (total + (current - 1)) % total;
      var prev = getters.playspotRoutes[prevIndex];
      commit(UPDATE_CURRENT_SCENARIO, prev);
      __WEBPACK_IMPORTED_MODULE_2_router__["a" /* default */].push({ query: prev });
    },
    updateCurrentScenario: function updateCurrentScenario(_ref3, path) {
      var commit = _ref3.commit;

      commit(UPDATE_CURRENT_SCENARIO, path);
    },
    activateSpot: function activateSpot(_ref4, spot) {
      var commit = _ref4.commit,
          getters = _ref4.getters;
      var scenario = getters.visibleScenarios[spot][0].scenario;

      __WEBPACK_IMPORTED_MODULE_2_router__["a" /* default */].push({ query: { spot: spot, scenario: scenario } });
    }
  },
  getters: {
    currentScenario: function currentScenario(state, getters, rootState) {
      var _rootState$route$quer = rootState.route.query,
          spot = _rootState$route$quer.spot,
          scenario = _rootState$route$quer.scenario;

      return state.current || { spot: spot, scenario: scenario };
    }
  }
};

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uid__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_highlight__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_shallow_equal__ = __webpack_require__(54);








var matches = function matches(filter, text) {
  var f = filter.toLowerCase();
  var t = text.toLowerCase();
  return t.includes(f);
};

/* harmony default export */ exports["a"] = {
  state: {
    logs: [],
    filter: ''
  },
  mutations: {
    ADD_LOG: function ADD_LOG(state, payload) {
      state.logs.push(payload);
    },
    CLEAR_CURRENT_LOGS: function CLEAR_CURRENT_LOGS(state, logs) {
      state.logs = logs;
    },
    UPDATE_FILTER: function UPDATE_FILTER(state, payload) {
      state.filter = payload;
    }
  },
  actions: {
    filterToys: function filterToys(_ref, payload) {
      var commit = _ref.commit;

      commit('UPDATE_FILTER', payload);
    },
    addLog: function addLog(_ref2, _ref3) {
      var commit = _ref2.commit;
      var data = _ref3.data,
          route = _ref3.route;

      commit('ADD_LOG', {
        data: data,
        route: route,
        id: __WEBPACK_IMPORTED_MODULE_4_uid___default()()
      });
    },
    clearLogs: function clearLogs(_ref4, payload) {
      var commit = _ref4.commit,
          state = _ref4.state;

      commit('CLEAR_CURRENT_LOGS', state.logs.filter(function (log) {
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_utils_shallow_equal__["a" /* default */])(payload, log.route);
      }));
    }
  },
  getters: {
    logs: function logs(state, getters) {
      return state.logs.filter(function (log) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_utils_shallow_equal__["a" /* default */])(log.route, getters.currentScenario);
      }).map(function (log) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, log, {
          data: __WEBPACK_IMPORTED_MODULE_5_utils_highlight__["a" /* default */].highlight('json', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(log.data, null, 2)).value
        });
      });
    },
    visibleScenarios: function visibleScenarios(_ref5, getters, _ref6) {
      var filter = _ref5.filter;
      var app = _ref6.app;

      if (!filter) return app.spots;
      var result = {};

      var _loop = function _loop(name) {
        var scenarios = app.spots[name];
        result[name] = scenarios.filter(function (scenario) {
          return matches(filter, name + ' ' + scenario.scenario);
        });
      };

      for (var name in app.spots) {
        _loop(name);
      }
      return result;
    },
    playspotRoutes: function playspotRoutes(state, _ref7) {
      var visibleScenarios = _ref7.visibleScenarios;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(visibleScenarios).map(function (name) {
        var scenarios = visibleScenarios[name];
        return scenarios.map(function (scenario) {
          return {
            scenario: scenario.scenario,
            spot: name
          };
        });
      }).reduce(function (current, next) {
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(current), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(next));
      }, []);
    },
    filterKeyword: function filterKeyword(state) {
      return state.filter;
    }
  }
};

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ exports["a"] = debounce;
function debounce(func, wait, immediate) {
  var timeout = void 0;

  return function () {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(_this, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(this, args);
  };
}

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_find_scenario__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_key_events__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tabs_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tabs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Tabs_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ exports["default"] = {
  watch: {
    current: 'updateIframe'
  },
  data: function data() {
    return {
      iframeLoaded: false
    };
  },
  mounted: function mounted() {
    this.updateIframe();
    this.listenChild();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_key_events__["a" /* observeKeyEvents */])(this.$store);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(['mainWidth']), {
    current: function current() {
      var spot = this.$route.query.spot;

      var _ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils_find_scenario__["a" /* default */])(this.$store.state.app.spots, this.$route.query) || {},
          scenario = _ref.scenario,
          component = _ref.component;

      if (!component) return {};

      return {
        spot: spot, scenario: scenario, component: component
      };
    },
    currentScenario: function currentScenario() {
      return {
        spot: this.current.spot,
        scenario: this.current.scenario
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['addLog', 'updateCurrentScenario', 'setSpots']), {
    postMessage: function postMessage() {
      this.$refs.iframe.contentWindow.postMessage({
        type: 'UPDATE_ROUTE',
        payload: this.currentScenario
      }, location.origin);
    },
    updateIframe: function updateIframe() {
      var _this = this;

      if (this.current.scenario) document.title = this.current.scenario + ' - Vue Play';else document.title = 'Vue Play';
      this.updateCurrentScenario(this.currentScenario);
      if (this.iframeLoaded) {
        this.postMessage();
      } else {
        this.$refs.iframe.onload = function () {
          _this.postMessage();
          _this.iframeLoaded = true;
        };
      }
    },
    listenChild: function listenChild() {
      var _this2 = this;

      window.addEventListener('message', function (_ref2) {
        var data = _ref2.data;

        if (data.type === 'SET_SPOTS') {
          _this2.setSpots(JSON.parse(data.payload));
        }
        if (data.type === 'APPLY_SHORTCUT') {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_key_events__["b" /* executeShortcut */])(_this2.$store, JSON.parse(data.payload));
        }
        if (data.type === 'ADD_LOG') {
          (function () {
            var _current = _this2.current,
                spot = _current.spot,
                scenario = _current.scenario;

            _this2.addLog({
              data: data.payload,
              route: {
                spot: spot, scenario: scenario
              }
            });
            var consoleEl = document.querySelector('.console-body');
            if (consoleEl) {
              _this2.$nextTick(function () {
                consoleEl.scrollTop = consoleEl.scrollHeight;
              });
            }
          })();
        }
      });
    }
  }),
  components: {
    Tabs: __WEBPACK_IMPORTED_MODULE_4__Tabs_vue___default.a
  }
};

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slim_modal__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slim_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_slim_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ exports["default"] = {
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['showHelp'])),
  components: {
    SlimModal: __WEBPACK_IMPORTED_MODULE_1_vue_slim_modal___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['toggleHelp']))
};

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sidebar_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Sidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppMain_vue__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppMain_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AppMain_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelpModal_vue__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelpModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__HelpModal_vue__);
//
//
//
//
//
//
//
//





/* harmony default export */ exports["default"] = {
  name: 'home',
  components: {
    Sidebar: __WEBPACK_IMPORTED_MODULE_0__Sidebar_vue___default.a,
    AppMain: __WEBPACK_IMPORTED_MODULE_1__AppMain_vue___default.a,
    HelpModal: __WEBPACK_IMPORTED_MODULE_2__HelpModal_vue___default.a
  }
};

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_prevent_select__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_debounce__ = __webpack_require__(62);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var BOUNDARY = {
  min: 200,
  max: 500
};

/* harmony default export */ exports["default"] = {
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['leftPanelExpanded', 'visibleScenarios', 'sidebarWidth', 'currentScenario', 'filterKeyword'])),

  data: function data() {
    return {
      resizing: false,
      startX: null,
      originalWidth: null,
      keyword: ''
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['updatePlayspot', 'updateSidebarWidth', 'toggleHelp', 'filterToys', 'activateSpot']), {
    filter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_debounce__["a" /* default */])(function (_ref) {
      var target = _ref.target;

      this.filterToys(target.value);
    }, 350),
    handleMouseDown: function handleMouseDown(_ref2) {
      var clientX = _ref2.clientX;

      this.resizing = true;
      this.startX = clientX;
      this.originalWidth = parseInt(this.$refs.sidebar.getBoundingClientRect().width, 10) || 0;
      document.addEventListener('mousemove', this.handleMouseMove);
      document.addEventListener('mouseup', this.handleMouseUp);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_prevent_select__["a" /* preventSelectStart */])();
    },
    handleMouseMove: function handleMouseMove(_ref3) {
      var clientX = _ref3.clientX;

      if (!this.resizing || clientX < BOUNDARY.min || clientX > BOUNDARY.max) return;
      this.updateSidebarWidth(this.originalWidth + clientX - this.startX);
    },
    handleMouseUp: function handleMouseUp() {
      this.resizing = false;
      document.removeEventListener('mousemove', this.handleMouseMove);
      document.removeEventListener('mouseup', this.handleMouseUp);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_prevent_select__["b" /* preventSelectStop */])();
    },
    isActiveSpot: function isActiveSpot(name, index) {
      if (this.filterKeyword) return true;
      if (!this.currentScenario.spot && index === 0) return true;
      return this.currentScenario.spot === name;
    }
  })
};

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_highlight__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_prevent_select__ = __webpack_require__(53);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ exports["default"] = {
  name: 'console',
  props: {
    example: {
      type: String
    },
    readme: {
      type: String
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(['logs', 'bottomPanelExpanded']), {
    highlightedExample: function highlightedExample() {
      if (!this.example) return;
      return __WEBPACK_IMPORTED_MODULE_2_utils_highlight__["a" /* default */].highlightAuto(this.example).value;
    },
    active: function active() {
      var tab = this.$store.getters.activeTab;
      if (tab === 'console' || tab && this[tab]) {
        return tab;
      }
      return this.readme ? 'readme' : 'console';
    }
  }),
  data: function data() {
    return {
      tabHeight: 200,
      startY: null,
      originalHeight: null,
      resizing: false
    };
  },
  mounted: function mounted() {
    this.boundary = {
      min: this.$refs.header.getBoundingClientRect().height,
      max: this.$refs.panel.parentNode.getBoundingClientRect().height
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['setBottomPanelHeight', 'clearLogs', 'updateActiveTab']), {
    handleMouseDown: function handleMouseDown(_ref) {
      var clientY = _ref.clientY;

      this.resizing = true;
      this.startY = clientY;
      this.originalHeight = parseInt(this.$refs.body.getBoundingClientRect().height, 10) || 0;
      document.addEventListener('mousemove', this.handleMouseMove);
      document.addEventListener('mouseup', this.handleMouseUp);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_prevent_select__["a" /* preventSelectStart */])();
    },
    handleMouseMove: function handleMouseMove(_ref2) {
      var clientY = _ref2.clientY;

      if (!this.resizing || clientY < this.boundary.min || clientY > this.boundary.max) return;
      var height = this.originalHeight - clientY + this.startY;
      this.setTabHeight(height);
    },
    handleMouseUp: function handleMouseUp() {
      this.resizing = false;
      this.setTabHeight(this.tabHeight);
      document.removeEventListener('mousemove', this.handleMouseMove);
      document.removeEventListener('mouseup', this.handleMouseUp);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_prevent_select__["b" /* preventSelectStop */])();
    },
    clearCurrentLogs: function clearCurrentLogs() {
      var _$route$query = this.$route.query,
          scenario = _$route$query.scenario,
          spot = _$route$query.spot;

      this.clearLogs({ scenario: scenario, spot: spot });
    },
    setTabHeight: function setTabHeight(height) {
      this.tabHeight = height;
    }
  })
};

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(70), __esModule: true };

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

exports.__esModule = true;

var _from = __webpack_require__(68);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(87);
__webpack_require__(86);
module.exports = __webpack_require__(0).Array.from;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(22)
  , TAG = __webpack_require__(19)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $defineProperty = __webpack_require__(11)
  , createDesc      = __webpack_require__(17);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1).document && document.documentElement;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(44)
  , ITERATOR   = __webpack_require__(19)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(7);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var create         = __webpack_require__(80)
  , descriptor     = __webpack_require__(17)
  , setToStringTag = __webpack_require__(55)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(10)(IteratorPrototype, __webpack_require__(19)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var LIBRARY        = __webpack_require__(79)
  , $export        = __webpack_require__(8)
  , redefine       = __webpack_require__(83)
  , hide           = __webpack_require__(10)
  , has            = __webpack_require__(9)
  , Iterators      = __webpack_require__(44)
  , $iterCreate    = __webpack_require__(76)
  , setToStringTag = __webpack_require__(55)
  , getPrototypeOf = __webpack_require__(82)
  , ITERATOR       = __webpack_require__(19)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(19)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ },
/* 79 */
/***/ function(module, exports) {

module.exports = true;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(7)
  , dPs         = __webpack_require__(81)
  , enumBugKeys = __webpack_require__(25)
  , IE_PROTO    = __webpack_require__(18)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(24)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(73).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(11)
  , anObject = __webpack_require__(7)
  , getKeys  = __webpack_require__(16);

module.exports = __webpack_require__(2) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(9)
  , toObject    = __webpack_require__(13)
  , IE_PROTO    = __webpack_require__(18)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(10);

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(6)
  , defined   = __webpack_require__(5);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(71)
  , ITERATOR  = __webpack_require__(19)('iterator')
  , Iterators = __webpack_require__(44);
module.exports = __webpack_require__(0).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var ctx            = __webpack_require__(23)
  , $export        = __webpack_require__(8)
  , toObject       = __webpack_require__(13)
  , call           = __webpack_require__(75)
  , isArrayIter    = __webpack_require__(74)
  , toLength       = __webpack_require__(27)
  , createProperty = __webpack_require__(72)
  , getIterFn      = __webpack_require__(85);

$export($export.S + $export.F * !__webpack_require__(78)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $at  = __webpack_require__(84)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(77)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ },
/* 88 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 89 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 90 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 91 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 92 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 93 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 94 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 95 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__

/* styles */
__webpack_require__(89)

/* script */
__vue_exports__ = __webpack_require__(63)

/* template */
var __vue_template__ = __webpack_require__(102)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__

/* styles */
__webpack_require__(88)

/* script */
__vue_exports__ = __webpack_require__(64)

/* template */
var __vue_template__ = __webpack_require__(101)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
__vue_options__._scopeId = "data-v-1a13c784"

module.exports = __vue_exports__


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__

/* styles */
__webpack_require__(94)

/* script */
__vue_exports__ = __webpack_require__(65)

/* template */
var __vue_template__ = __webpack_require__(104)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__

/* styles */
__webpack_require__(95)

/* script */
__vue_exports__ = __webpack_require__(66)

/* template */
var __vue_template__ = __webpack_require__(105)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
__vue_options__._scopeId = "data-v-bea00ba4"

module.exports = __vue_exports__


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__

/* styles */
__webpack_require__(91)
__webpack_require__(90)
__webpack_require__(92)
__webpack_require__(93)

/* script */
__vue_exports__ = __webpack_require__(67)

/* template */
var __vue_template__ = __webpack_require__(103)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
__vue_options__._scopeId = "data-v-669b671c"

module.exports = __vue_exports__


/***/ },
/* 101 */
/***/ function(module, exports) {

module.exports={render:function (){with(this) {
  return _h('slim-modal', {
    staticClass: "help-modal",
    style: ({
      padding: 0
    }),
    attrs: {
      "overlay-style": {
        backgroundColor: 'rgba(0, 0, 0, 0.74902)'
      },
      "is-open": showHelp,
      "click-outside": toggleHelp
    }
  }, [_m(0), " ", _m(1), " ", _h('div', {
    staticClass: "modal-footer"
  }, [_h('button', {
    staticClass: "play-button",
    on: {
      "click": toggleHelp
    }
  }, ["Close"]), " ", _m(2)])])
}},staticRenderFns: [function (){with(this) {
  return _h('h2', {
    staticClass: "modal-header"
  }, ["\n    Shortcuts\n  "])
}},function (){with(this) {
  return _h('div', {
    staticClass: "modal-body"
  }, [_h('div', {
    staticClass: "shortcut"
  }, [_h('span', {
    staticClass: "kbd"
  }, ["Command/Ctrl + Shift + L"]), " ", _h('span', {
    staticClass: "desc"
  }, ["Toggle Left Panel"])]), " ", _h('div', {
    staticClass: "shortcut"
  }, [_h('span', {
    staticClass: "kbd"
  }, ["Command/Ctrl + Shift + D"]), " ", _h('span', {
    staticClass: "desc"
  }, ["Toggle Down Panel"])]), " ", _h('div', {
    staticClass: "shortcut"
  }, [_h('span', {
    staticClass: "kbd"
  }, ["Command/Ctrl + Shift + K"]), " ", _h('span', {
    staticClass: "desc"
  }, ["Toggle All Panels"])]), " ", _h('div', {
    staticClass: "shortcut"
  }, [_h('span', {
    staticClass: "kbd"
  }, ["Command/Ctrl + Shift + ←"]), " ", _h('span', {
    staticClass: "desc"
  }, ["Play Previous Example"])]), " ", _h('div', {
    staticClass: "shortcut"
  }, [_h('span', {
    staticClass: "kbd"
  }, ["Command/Ctrl + Shift + →"]), " ", _h('span', {
    staticClass: "desc"
  }, ["Play Next Example"])])])
}},function (){with(this) {
  return _h('a', {
    staticClass: "play-repo",
    attrs: {
      "href": "https://github.com/vue-play/vue-play"
    }
  }, ["\n      Check out vue-play on GitHub\n    "])
}}]}

/***/ },
/* 102 */
/***/ function(module, exports) {

module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "main",
    style: ({
      width: mainWidth
    })
  }, [_h('div', {
    staticClass: "view"
  }, [_h('iframe', {
    ref: "iframe",
    staticClass: "play-ground",
    attrs: {
      "src": "preview.html",
      "frameborder": "0"
    }
  }), " ", (current.component) ? _h('tabs', {
    attrs: {
      "example": current.component.example,
      "readme": current.component.readme
    }
  }) : _e()])])
}},staticRenderFns: []}

/***/ },
/* 103 */
/***/ function(module, exports) {

module.exports={render:function (){with(this) {
  return _h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (bottomPanelExpanded),
      expression: "bottomPanelExpanded"
    }],
    ref: "panel",
    staticClass: "play-tabs"
  }, [(resizing) ? _h('div', {
    staticClass: "resize-indicator"
  }, ["H: " + _s(tabHeight) + "px"]) : _e(), " ", _h('div', {
    ref: "header",
    staticClass: "tab-header",
    on: {
      "mousedown": handleMouseDown,
      "mouseup": handleMouseUp
    }
  }, [(readme) ? _h('span', {
    staticClass: "title",
    class: {
      active: active === 'readme'
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      },
      "click": function($event) {
        updateActiveTab('readme')
      }
    }
  }, [_h('svg', {
    attrs: {
      "id": "i-book",
      "viewBox": "0 0 32 32",
      "width": "32",
      "height": "32",
      "fill": "none",
      "stroke": "currentcolor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "6.25%"
    }
  }, [_h('path', {
    attrs: {
      "d": "M16 7 C16 7 9 1 2 6 L2 28 C9 23 16 28 16 28 16 28 23 23 30 28 L30 6 C23 1 16 7 16 7 Z M16 7 L16 28"
    }
  })]), "\n      readme\n    "]) : _e(), " ", _h('span', {
    staticClass: "title",
    class: {
      active: active === 'console'
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      },
      "click": function($event) {
        updateActiveTab('console')
      }
    }
  }, [_h('svg', {
    attrs: {
      "id": "i-bell",
      "viewBox": "0 0 32 32",
      "width": "32",
      "height": "32",
      "fill": "none",
      "stroke": "currentcolor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "6.25%"
    }
  }, [_h('path', {
    attrs: {
      "d": "M8 17 C8 12 9 6 16 6 23 6 24 12 24 17 24 22 27 25 27 25 L5 25 C5 25 8 22 8 17 Z M20 25 C20 25 20 29 16 29 12 29 12 25 12 25 M16 3 L16 6"
    }
  })]), "\n      console", (logs.length > 0) ? _h('sup', {
    staticClass: "logs-count"
  }, [_s(logs.length)]) : _e()]), " ", (example) ? _h('span', {
    staticClass: "title",
    class: {
      active: active === 'example'
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      },
      "click": function($event) {
        updateActiveTab('example')
      }
    }
  }, [_h('svg', {
    attrs: {
      "id": "i-code",
      "viewBox": "0 0 32 32",
      "width": "32",
      "height": "32",
      "fill": "none",
      "stroke": "currentcolor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "6.25%"
    }
  }, [_h('path', {
    attrs: {
      "d": "M10 9 L3 17 10 25 M22 9 L29 17 22 25 M18 7 L14 27"
    }
  })]), "\n      Example\n    "]) : _e(), " ", _h('div', {
    staticClass: "tab-actions"
  }, [(logs.length > 0 && active === 'console') ? _h('span', {
    staticClass: "tab-action hint--top-left hint--rounded",
    attrs: {
      "aria-label": "clean logs"
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      },
      "click": clearCurrentLogs
    }
  }, [_h('svg', {
    attrs: {
      "id": "i-trash",
      "viewBox": "0 0 32 32",
      "width": "32",
      "height": "32",
      "fill": "none",
      "stroke": "currentcolor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "6.25%"
    }
  }, [_h('path', {
    attrs: {
      "d": "M28 6 L6 6 8 30 24 30 26 6 4 6 M16 12 L16 24 M21 12 L20 24 M11 12 L12 24 M12 6 L13 2 19 2 20 6"
    }
  })])]) : _e(), " ", (tabHeight !== 0) ? _h('span', {
    staticClass: "tab-action hint--top-left hint--rounded",
    attrs: {
      "aria-label": "Minimize the tab"
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      },
      "click": function($event) {
        setTabHeight(0)
      }
    }
  }, [_h('svg', {
    attrs: {
      "id": "i-external",
      "viewBox": "0 0 32 32",
      "width": "32",
      "height": "32",
      "fill": "none",
      "stroke": "currentcolor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "4.25%"
    }
  }, [_h('path', {
    attrs: {
      "d": "M5 5 L28 5 L28 28 L5 28 L5 5 M10 22 L23 22"
    }
  })])]) : _h('span', {
    staticClass: "tab-action hint--top-left hint--rounded",
    attrs: {
      "aria-label": "Reset the tab height"
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      },
      "click": function($event) {
        setTabHeight(200)
      }
    }
  }, [_h('svg', {
    attrs: {
      "viewBox": "0 0 32 32",
      "width": "32",
      "height": "32",
      "fill": "none",
      "stroke": "currentcolor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "4.25%"
    }
  }, [_h('path', {
    attrs: {
      "d": "M5 5 L28 5 L28 28 L5 28 L5 5 M10 10 L23 10 L23 20 L10 20 L10 10"
    }
  })])]), " "])]), " ", (active === 'readme') ? _h('div', {
    ref: "body",
    staticClass: "tab-body",
    style: ({
      padding: '10px',
      height: tabHeight + 'px'
    })
  }, [_h('div', {
    staticClass: "markdown-body",
    domProps: {
      "innerHTML": _s(readme)
    }
  })]) : _e(), " ", (active === 'console') ? _h('div', {
    ref: "body",
    staticClass: "tab-body console-body",
    style: ({
      height: tabHeight + 'px'
    })
  }, [_l((logs), function(log) {
    return _h('div', {
      staticClass: "console-item"
    }, [_h('pre', [_h('code', {
      domProps: {
        "innerHTML": _s(log.data)
      }
    })])])
  })]) : _e(), " ", (active === 'example') ? _h('div', {
    ref: "body",
    staticClass: "tab-body",
    style: ({
      height: tabHeight + 'px'
    })
  }, [_h('pre', [_h('code', {
    domProps: {
      "innerHTML": _s(highlightedExample)
    }
  })])]) : _e()])
}},staticRenderFns: []}

/***/ },
/* 104 */
/***/ function(module, exports) {

module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "app"
  }, [_h('help-modal'), " ", _h('sidebar'), " ", _h('app-main')])
}},staticRenderFns: []}

/***/ },
/* 105 */
/***/ function(module, exports) {

module.exports={render:function (){with(this) {
  return _h('figure', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (leftPanelExpanded),
      expression: "leftPanelExpanded"
    }],
    ref: "sidebar",
    staticClass: "sidebar",
    style: ({
      width: sidebarWidth
    })
  }, [(resizing) ? _h('div', {
    staticClass: "resize-indicator"
  }, ["W: " + _s(sidebarWidth)]) : _e(), " ", _h('div', {
    staticClass: "sidebar-border",
    on: {
      "mousedown": handleMouseDown,
      "mouseup": handleMouseUp
    }
  }), " ", _h('h1', {
    on: {
      "click": toggleHelp
    }
  }, ["Vue Play"]), " ", _h('div', {
    staticClass: "sidebar-search"
  }, [_h('input', {
    attrs: {
      "placeholder": "Type to filter components..."
    },
    on: {
      "input": filter
    }
  })]), " ", _h('div', {
    staticClass: "scenarios"
  }, [_l((visibleScenarios), function(scenarios, name, index) {
    return _h('ul', {
      staticClass: "nav-spots",
      class: {
        active: isActiveSpot(name, index)
      }
    }, [_h('li', {
      staticClass: "nav-spot"
    }, [(scenarios.length > 0) ? _h('div', {
      staticClass: "component-name",
      on: {
        "click": function($event) {
          activateSpot(name)
        }
      }
    }, ["\n          " + _s(name) + "\n        "]) : _e(), " ", _h('ul', {
      staticClass: "nav-scenarios"
    }, [_l((scenarios), function(scenario) {
      return _h('li', {
        staticClass: "nav-scenario"
      }, [_h('router-link', {
        attrs: {
          "exact": "",
          "to": {
            query: {
              spot: name,
              scenario: scenario.scenario
            }
          }
        }
      }, ["\n              " + _s(scenario.scenario) + "\n            "])])
    })])])])
  })])])
}},staticRenderFns: []}

/***/ },
/* 106 */
/***/ function(module, exports) {

module.exports = require("array-find-index");

/***/ },
/* 107 */
/***/ function(module, exports) {

module.exports = require("highlight.js/lib/highlight");

/***/ },
/* 108 */
/***/ function(module, exports) {

module.exports = require("highlight.js/lib/languages/javascript");

/***/ },
/* 109 */
/***/ function(module, exports) {

module.exports = require("highlight.js/lib/languages/json");

/***/ },
/* 110 */
/***/ function(module, exports) {

module.exports = require("highlight.js/lib/languages/xml");

/***/ },
/* 111 */
/***/ function(module, exports) {

module.exports = require("uid");

/***/ },
/* 112 */
/***/ function(module, exports) {

module.exports = require("vue-router");

/***/ },
/* 113 */
/***/ function(module, exports) {

module.exports = require("vue-slim-modal");

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(51);





/* harmony default export */ exports["default"] = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$spots = _ref.spots,
      spots = _ref$spots === undefined ? [] : _ref$spots;

  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].registerModule('app', {
    state: {
      spots: spots
    },
    mutations: {
      SET_SPOTS: function SET_SPOTS(state, payload) {
        state.spots = payload;
      }
    },
    actions: {
      setSpots: function setSpots(_ref2, payload) {
        var commit = _ref2.commit;

        commit('SET_SPOTS', payload);
      }
    }
  });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);

  return new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    render: function render(h) {
      return h('router-view');
    }
  });
};

/***/ }
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./~/vue-play/dist/app.js
// module id = 17
// module chunks = 0